import { Tooltip, Space, Popconfirm, Tag, Typography } from "antd";
import { DeleteTwoTone, EditTwoTone, MinusCircleOutlined } from "@ant-design/icons";
import { COLOR_PRIMARY } from "../../constants";
import get from "lodash/get";
import { getTemplateTagColor } from "./templates";

const { Text } = Typography;

export const productionComponentColumns = (toggleModal, onDelete, isStaff) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "production_component_column",
    render: (text) => {
      return (
        <Text strong color="green">
          {text ? text : "--"}
        </Text>
      );
    },
  },
  {
    title: "Template type",
    dataIndex: ["type", "name"],
    key: "template_type_column",
    render: (text, record) => {
      return (
        <Tag
          color={getTemplateTagColor(get(record, "type.value"))}
          className="min-w-[150px] text-center"
        >
          {text?text:"--"}
        </Tag>
      );
    },
  },
  {
    title: "Die/Tool/Serial No",
    dataIndex: "serial_number",
    key: "serial_number",
    render: (text) => <p>{text ? text : "--"}</p>,
  },
  {
    title: "Number of Parts",
    dataIndex: "parts",
    key: "parts",
    render: (text) => {
      return (
        <div className="w-[100px]">
          <p color="green" className="text-center">
            {get(text, "length")}
          </p>
        </div>
      );
    },
  },
  {
    title: "Action",
    key: "action_column",
    render: (record) => {
      if (get(record, "is_default")) {
        return <Tag color="default" icon={<MinusCircleOutlined />}>Default</Tag>;
      }
      return (
        <Space className="gap-[1.5rem]" size="large">
          <Tooltip title="Edit Production Component">
            <EditTwoTone
              style={{ fontSize: 20 }}
              twoToneColor={COLOR_PRIMARY}
              onClick={() => {
                toggleModal(record);
              }}
            />
          </Tooltip>
          {!isStaff&&(

            <Popconfirm
            title="Delete Production Component"
            description="Are you sure to delete this Production Component?"
            onConfirm={() => onDelete(get(record, "id"))}
            okText="Yes"
            cancelText="No"
            >
            <Tooltip title="Delete Production Component">
              <DeleteTwoTone
                style={{ fontSize: 20 }}
                twoToneColor={COLOR_PRIMARY}
                />
            </Tooltip>
          </Popconfirm>
              )}
        </Space>
      );
    },
  },
];

export const productionComponentArr = [
  {
    company: {
      id: "12345666",
      name: "xyz",
    },
    template_type: { id: "1", name: "Injection Moulding" },
    name: "demo",
    parts: [
      "eb73add9-699d-4531-a078-8573d434dc53",
      "4ac33644-bb83-4e02-86ef-4240aa06599c",
      "d9972ba4-22ed-4c54-aca3-e5c142b57e28",
      "befa20dc-0b5b-425b-a51d-45561a546969",
    ],
  },
  {
    company: {
      id: "12345665",
      name: "abc",
    },
    template_type: { id: "2", name: "CNC" },
    name: "demo1",
    parts: [
      "eb73add9-699d-4531-a078-8573d434dc53",
      "f6cebb5d-9708-4eff-9726-e3bd2f801907",
    ],
  },
  {
    company: {
      id: "12345656",
      name: "def",
    },
    template_type: { id: "1", name: "Injection Moulding" },
    name: "demo2",
    parts: [
      "eb73add9-699d-4531-a078-8573d434dc53",
      "f6cebb5d-9708-4eff-9726-e3bd2f801907",
      "4ac33644-bb83-4e02-86ef-4240aa06599c",
      "d9972ba4-22ed-4c54-aca3-e5c142b57e28",
      "befa20dc-0b5b-425b-a51d-45561a546969",
    ],
  },
  {
    company: {
      id: "12345696",
      name: "ghi",
    },
    template_type: { id: "2", name: "CNC" },
    name: "demo3",
    parts: [
      "eb73add9-699d-4531-a078-8573d434dc53",
      "f6cebb5d-9708-4eff-9726-e3bd2f801907",
      "befa20dc-0b5b-425b-a51d-45561a546969",
    ],
  },
];
